var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-container" }, [
    _vm._v(" 测试页面 "),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }